export const fakedata = [
    {
        bagTimelineNodes: [
            {
                stationCode: 'DFW',
                sortOrder: 0,
                timestamp: '2023-04-01T20:41:32.1145697',
                description: 'Activation',
                state: 'Future',
            },
            {
                stationCode: 'DFW',
                sortOrder: 1,
                timestamp: '2023-04-01T20:41:32.1145697',
                description: 'Activation',
                state: 'Missed',
            },
            {
                stationCode: 'DFW',
                sortOrder: 2,
                description: 'Load',
                state: 'CompletedBag',
            },
            {
                stationCode: 'DFW',
                sortOrder: 3,
                description: 'Departure',
                state: 'CompletedFlight',
            },
            {
                stationCode: 'YUL',
                sortOrder: 4,
                description: 'Arrival',
                state: 'Future',
            },
            {
                stationCode: 'YUL',
                sortOrder: 5,
                description: 'Load',
                state: 'Future',
            },
        ],
        bagTransactions: [
            {
                stationCode: 'DFW',
                eventTime: '2023-04-01T20:41:32.1145697',
                transactionType: 'Activation',
                extensionProperties: '{"WorkstationName":""}',
            },
        ],
        bagSelectorResult: {
            id: '847381',
            bagTag: '0014182499',
            passengerName: 'BOROUGHS/TANDYKENMR',
            pnr: '354553',
            createdOn: '2023-05-31T13:37:07.5625876',

            flightItinerary: [
                {
                    flightIdentifier: '132913',
                    carrierCode: 'AC',
                    flightNumber: '8812',
                    departureStation: 'DFW',
                    arrivalStation: 'YUL',
                    departureDate: '2023-04-01T00:00:00',
                    arrivalDate: '0001-01-01T00:00:00',
                },
                {
                    flightIdentifier: '-2',
                    carrierCode: 'LH',
                    flightNumber: '0475',
                    departureStation: 'YUL',
                    arrivalStation: 'MUC',
                    departureDate: '2023-04-01T00:00:00',
                    arrivalDate: '0001-01-01T00:00:00',
                },
            ],
            createdOn: '2023-05-23T17:59:28.8864079',
        },
    },
];

export const Scenarios = [
    //#1 ALL COMPLETED EVENTS
    {
        bagTimelineNodes: [
            {
                stationCode: 'DFW',
                sortOrder: 0,
                timestamp: '2023-04-01T20:41:32.1145697',
                description: 'Creation',
                state: 'CompletedBag',
            },
            {
                stationCode: 'DFW',
                sortOrder: 1,
                timestamp: '2023-04-01T20:41:32.1145697',
                description: 'Activation',
                state: 'CompletedBag',
            },
            {
                stationCode: 'DFW',
                sortOrder: 2,
                description: 'Load',
                state: 'CompletedBag',
            },
            {
                stationCode: 'DFW',
                sortOrder: 3,
                description: 'Departure',
                state: 'CompletedFlight',
            },
            {
                stationCode: 'YUL',
                sortOrder: 4,
                description: 'Arrival',
                state: 'CompletedFlight',
            },
            {
                stationCode: 'YUL',
                sortOrder: 5,
                description: 'Unload',
                state: 'CompletedBag',
            },
            {
                stationCode: 'YUL',
                sortOrder: 6,
                description: 'Delivery',
                state: 'CompletedBag',
            },
        ],
        bagTransactions: [
            {
                stationCode: 'DFW',
                eventTime: '2023-04-01T20:41:32.1145697',
                transactionType: 'Activation',
                extensionProperties: '{"WorkstationName":""}',
            },
        ],
        bagSelectorResult: {
            id: '847381',
            bagTag: '0014182499',
            passengerName: 'All completed events ',
            pnr: '354551',
            createdOn: '2023-05-31T13:37:07.5625876',
            flightItinerary: [
                {
                    flightIdentifier: '132913',
                    carrierCode: 'AC',
                    flightNumber: '8812',
                    departureStation: 'DFW',
                    arrivalStation: 'YUL',
                    departureDate: '2023-04-01T00:00:00',
                    arrivalDate: '0001-01-01T00:00:00',
                },
            ],
            createdOn: '2023-02-23T17:59:28.8864079',
        },
    },

    //SCENARIO #2 -Missed Load at departure Station
    {
        bagTimelineNodes: [
            {
                stationCode: 'DFW',
                sortOrder: 0,
                timestamp: '2023-04-01T20:41:32.1145697',
                description: 'Creation',
                state: 'CompletedBag',
            },
            {
                stationCode: 'DFW',
                sortOrder: 1,
                timestamp: '2023-04-01T20:41:32.1145697',
                description: 'Activation',
                state: 'CompletedBag',
            },
            {
                stationCode: 'DFW',
                sortOrder: 2,
                description: 'Load',
                state: 'Missed',
            },
            {
                stationCode: 'DFW',
                sortOrder: 3,
                description: 'Departure',
                state: 'CompletedFlight',
            },
            {
                stationCode: 'YUL',
                sortOrder: 4,
                description: 'Arrival',
                state: 'CompletedFlight',
            },
        ],
        bagTransactions: [
            {
                stationCode: 'DFW',
                eventTime: '2023-04-01T20:41:32.1145697',
                transactionType: 'Activation',
                extensionProperties: '{"WorkstationName":""}',
            },
        ],
        bagSelectorResult: {
            id: '847382',
            bagTag: '0014182499',
            passengerName: 'Missed Load at departure ',
            pnr: '354552',
            createdOn: '2023-05-31T13:37:07.5625876',
            flightItinerary: [
                {
                    flightIdentifier: '132913',
                    carrierCode: 'AC',
                    flightNumber: '8812',
                    departureStation: 'DFW',
                    arrivalStation: 'YUL',
                    departureDate: '2023-04-01T00:00:00',
                    arrivalDate: '0001-01-01T00:00:00',
                },
            ],
            createdOn: '2023-06-01T17:59:28.8864079',
        },
    },

    //SCENARIO #3 -Missed Load at Departure Station
    {
        bagTimelineNodes: [
            {
                stationCode: 'DFW',
                sortOrder: 0,
                timestamp: '2023-04-01T20:41:32.1145697',
                description: 'Creation',
                state: 'CompletedBag',
            },
            {
                stationCode: 'DFW',
                sortOrder: 1,
                timestamp: '2023-04-01T20:41:32.1145697',
                description: 'Activation',
                state: 'CompletedBag',
            },
            {
                stationCode: 'DFW',
                sortOrder: 2,
                description: 'Load',
                state: 'CompletedBag',
            },
            {
                stationCode: 'DFW',
                sortOrder: 3,
                description: 'Departure',
                state: 'CompletedFlight',
            },
            {
                stationCode: 'YUL',
                sortOrder: 4,
                description: 'Arrival',
                state: 'CompletedFlight',
            },
            {
                stationCode: 'YUL',
                sortOrder: 5,
                description: 'Load',
                state: 'Missed',
            },
            {
                stationCode: 'YUL',
                sortOrder: 6,
                description: 'Departure',
                state: 'CompletedFlight',
            },
            {
                stationCode: 'NAP',
                sortOrder: 7,
                description: 'Arrival',
                state: 'CompletedFlight',
            },
        ],
        bagTransactions: [
            {
                stationCode: 'DFW',
                eventTime: '2023-04-01T20:41:32.1145697',
                transactionType: 'Activation',
                extensionProperties: '{"WorkstationName":""}',
            },
        ],
        bagSelectorResult: {
            id: '847383',
            bagTag: '0014182499',
            passengerName: 'Missed Load at arrival',
            pnr: '354553',
            createdOn: '2023-05-31T13:37:07.5625876',
            flightItinerary: [
                {
                    flightIdentifier: '132913',
                    carrierCode: 'AC',
                    flightNumber: '8812',
                    departureStation: 'DFW',
                    arrivalStation: 'YUL',
                    departureDate: '2023-04-01T00:00:00',
                    arrivalDate: '0001-01-01T00:00:00',
                },
                {
                    flightIdentifier: '-2',
                    carrierCode: 'LH',
                    flightNumber: '0475',
                    departureStation: 'YUL',
                    arrivalStation: 'NAP',
                    departureDate: '2023-04-01T00:00:00',
                    arrivalDate: '0001-01-01T00:00:00',
                },
            ],
            createdOn: '2023-01-23T17:59:28.8864079',
        },
    },
    //Scenario 4 is re-flight

    //SCENARIO #5 -Picked Up Load Node
    {
        bagTimelineNodes: [
            {
                stationCode: 'DFW',
                sortOrder: 0,
                timestamp: '2023-04-01T20:41:32.1145697',
                description: 'Creation',
                state: 'CompletedBag',
            },
            {
                stationCode: 'DFW',
                sortOrder: 1,
                timestamp: '2023-04-01T20:41:32.1145697',
                description: 'Activation',
                state: 'CompletedBag',
            },
            {
                stationCode: 'DFW',
                sortOrder: 2,
                description: 'Load',
                state: 'Missed',
            },
            {
                stationCode: 'DFW',
                sortOrder: 3,
                description: 'Departure',
                state: 'CompletedFlight',
            },
            {
                stationCode: 'YUL',
                sortOrder: 4,
                description: 'Arrival',
                state: 'CompletedFlight',
            },
            {
                stationCode: 'YUL',
                sortOrder: 5,
                description: 'Load',
                state: 'CompletedBag',
            },
            {
                stationCode: 'YUL',
                sortOrder: 6,
                description: 'UldPositioning',
                state: 'CompletedBag',
            },
            {
                stationCode: 'YUL',
                sortOrder: 7,
                description: 'Departure',
                state: 'Future',
            },
            {
                stationCode: 'NAP',
                sortOrder: 8,
                description: 'Arrival',
                state: 'Future',
            },
        ],
        bagTransactions: [
            {
                stationCode: 'DFW',
                eventTime: '2023-04-01T20:41:32.1145697',
                transactionType: 'Activation',
                extensionProperties: '{"WorkstationName":""}',
            },
        ],
        bagSelectorResult: {
            id: '847384',
            bagTag: '0014182499',
            passengerName: 'Picked up a load node ',
            pnr: '354554',
            createdOn: '2023-05-31T13:37:07.5625876',
            flightItinerary: [
                {
                    flightIdentifier: '132913',
                    carrierCode: 'AC',
                    flightNumber: '8812',
                    departureStation: 'DFW',
                    arrivalStation: 'YUL',
                    departureDate: '2023-04-01T00:00:00',
                    arrivalDate: '0001-01-01T00:00:00',
                },
                {
                    flightIdentifier: '-2',
                    carrierCode: 'LH',
                    flightNumber: '0475',
                    departureStation: 'YUL',
                    arrivalStation: 'MUC',
                    departureDate: '2023-04-01T00:00:00',
                    arrivalDate: '0001-01-01T00:00:00',
                },
            ],
            createdOn: '2023-06-02T17:59:28.8864079',
        },
    },

    //Scenario 6: Bag Offloaded

    {
        bagTimelineNodes: [
            {
                stationCode: 'DFW',
                sortOrder: 0,
                timestamp: '2023-04-01T20:41:32.1145697',
                description: 'Creation',
                state: 'CompletedBag',
            },
            {
                stationCode: 'DFW',
                sortOrder: 1,
                timestamp: '2023-04-01T20:41:32.1145697',
                description: 'Activation',
                state: 'CompletedBag',
            },
            {
                stationCode: 'DFW',
                sortOrder: 2,
                description: 'Load',
                state: 'CompletedBag',
            },
            {
                stationCode: 'DFW',
                sortOrder: 3,
                description: 'Offload',
                state: 'CompletedBag',
            },
            {
                stationCode: 'DFW',
                sortOrder: 4,
                description: 'Load',
                state: 'Future',
            },
            {
                stationCode: 'DFW',
                sortOrder: 5,
                description: 'Departure',
                state: 'Future',
            },
            {
                stationCode: 'YUL',
                sortOrder: 6,
                description: 'Arrival',
                state: 'Future',
            },
        ],
        bagTransactions: [
            {
                stationCode: 'DFW',
                eventTime: '2023-04-01T20:41:32.1145697',
                transactionType: 'Activation',
                extensionProperties: '{"WorkstationName":""}',
            },
        ],
        bagSelectorResult: {
            id: '847385',
            bagTag: '0014182499',
            passengerName: 'Bag offloaded ',
            pnr: '354555',
            createdOn: '2023-05-31T13:37:07.5625876',
            flightItinerary: [
                {
                    flightIdentifier: '132913',
                    carrierCode: 'AC',
                    flightNumber: '8812',
                    departureStation: 'DFW',
                    arrivalStation: 'YUL',
                    departureDate: '2023-04-01T00:00:00',
                    arrivalDate: '0001-01-01T00:00:00',
                },
            ],
            createdOn: '2023-01-01T17:59:28.8864079',
        },
    },

    //#7 Bag Offloaded and Loaded
    {
        bagTimelineNodes: [
            {
                stationCode: 'DFW',
                sortOrder: 0,
                timestamp: '2023-04-01T20:41:32.1145697',
                description: 'Creation',
                state: 'CompletedBag',
            },
            {
                stationCode: 'DFW',
                sortOrder: 1,
                timestamp: '2023-04-01T20:41:32.1145697',
                description: 'Activation',
                state: 'CompletedBag',
            },
            {
                stationCode: 'DFW',
                sortOrder: 2,
                description: 'Load',
                state: 'CompletedBag',
            },

            {
                stationCode: 'DFW',
                sortOrder: 5,
                description: 'Departure',
                state: 'CompletedFlight',
            },
            {
                stationCode: 'YUL',
                sortOrder: 6,
                description: 'Arrival',
                state: 'Future',
            },
        ],
        bagTransactions: [
            {
                stationCode: 'DFW',
                eventTime: '2023-04-01T20:41:32.1145697',
                transactionType: 'Activation',
                extensionProperties: '{"WorkstationName":""}',
            },
        ],
        bagSelectorResult: {
            id: '847386',
            bagTag: '0014182499',
            passengerName: 'Bag Offloaded/unloaded ',
            pnr: '354556',
            createdOn: '2023-05-31T13:37:07.5625876',
            flightItinerary: [
                {
                    flightIdentifier: '132913',
                    carrierCode: 'AC',
                    flightNumber: '8812',
                    departureStation: 'DFW',
                    arrivalStation: 'YUL',
                    departureDate: '2023-04-01T00:00:00',
                    arrivalDate: '0001-01-01T00:00:00',
                },
            ],
            createdOn: '2023-03-23T17:59:28.8864079',
        },
    },
];
